
import { Column } from "primereact/column";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import MeaDataTable from "../../../../components/MeaDataTable";
import { InputText } from "primereact/inputtext";
import CreateFolderModal from "./CreateFolderModal";
import documentsAPI from "../../../../services/documents";
import UpdateDocumentModal from "./UpdateDocumentModal";
import { useLoaderData, useParams } from "react-router-dom";
import { PERMISSION_TRAINING_CLASSROOMS } from "../../../../permissions";
import MeaButton from "../../../../components/MeaButton";
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import useUrlState from "@ahooksjs/use-url-state";
import MeaSvgIcon from "../../../../components/icons/MeaSvgIcon";
import UploadFilesModal from "../modals/UploadFilesModal";
import { useAuthContext } from "../../../../hooks/useAuthContext";

const DocumentsListComponent = forwardRef((props, ref) => {

  const { training } = useLoaderData();

  const { selectedFields, showAddButton } = props;
  const { hasPermission } = useAuthContext();
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.trainingId;
  const accessToken = "";

  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();

  //
  const createModalRef = useRef();
  const updateModalRef = useRef();
  const uploadModalRef = useRef();
  //
  let selectedData = {
    select: selectedFields?.select ?? true,
    name: selectedFields?.name ?? true,
    presentation: selectedFields?.presentation ?? true,
    edit: selectedFields?.edit ?? true,
  };
  const [state, setState] = useUrlState({
    parentId: props?.filter?.parentId || "",
  });
  let filters = {
    parentId: state.parentId || "",
  };
  //
  const [documentObject, setDocumentObject] = useState(null);
  //
  const queryList = documentsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
    filters
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  // 'secondary' | 'success' | 'info' | 'warning' | 'danger' | 'help' | 'contrast' | undefined;
  let items = (queryList?.data?.extraMeta?.parent_id && (props?.filter?.parentId === undefined || (props?.filter?.parentId !== undefined && (queryList?.data?.extraMeta?.id !== props?.filter?.parentId)))) ?
    [{
      icon: 'pi pi-directions-alt', template: (item, options) => {
        return (
          <Button icon='pi pi-directions-alt' style={{ height: "18px" }} text severity="contrast" className={options.className}
            onClick={() => {
              setState((s) => ({
                documentsPage: 1,
                parentId: queryList?.data?.extraMeta?.parent_id,
              }))
            }} tooltip="Retour" tooltipOptions={{ position: "bottom" }}></Button>
        );
      }

    }, { label: queryList?.data?.extraMeta?.name }] : [{ label: queryList?.data?.extraMeta?.name }];
  const home = {
    icon: 'pi pi-home', command: () => {
      //navigate("/school/" + schoolId + "/admin/trainings/" + trainingId + "/documents") 
      setState((s) => ({
        documentsPage: 1,
        parentId: props?.filter?.parentId || "",
      }));
    }
  }
  //
  const startToolbarTemplate = (
    <div>
      {showAddButton && (
        <>
          <MeaButton
            label="Créer un dossier"
            outlined
            disabled={!training?.training_folder_id}
            icon="pi pi-plus"
            size="small"
            className="p-button mr-2 action"
            onClick={() => {
              createModalRef.current.show(() => {
                queryList.refetch();
              });
            }}
            data-pr-tooltip="Nouveau dossier"
          //permission={PERMISSION_TRAINING_CLASSROOMS.CREATE}
          />
          <MeaButton
            label="Charger des fichiers"
            outlined
            disabled={!training?.training_folder_id}
            icon="pi pi-cloud-upload"
            size="small"
            className="p-button mr-2 action"
            onClick={() => {
              uploadModalRef.current.show(() => {
                queryList.refetch();
              }, state.parentId);
            }}
            data-pr-tooltip="Nouveau dossier"
          //permission={PERMISSION_TRAINING_CLASSROOMS.CREATE}
          />
        </>
      )}

    </div>
  );
  //
  return (
    <>
      <UploadFilesModal ref={uploadModalRef} />
      <CreateFolderModal ref={createModalRef} parentId={state.parentId || ""} />
      <BreadCrumb className="mp-2" model={items} home={home} />
      <MeaDataTable
        query={queryList}
        serviceAPI={documentsAPI}
        onChangeCallback={(e) => {
          queryList.refetch();
        }}
        names={{ pagination: "documents", singular: "document", plural: "documents" }}
        startToolbarTemplate={startToolbarTemplate}
        showDeleteButton={hasPermission(PERMISSION_TRAINING_CLASSROOMS.DELETE)}
        showFilterButton={false}
        setPage={setPage}
        setPageSize={setPageSize}
      >
        {selectedData.select && <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>}
        {selectedData.name && (
          <Column
            field="name"
            header="Document"
            editor={(options) => (
              <InputText
                type="text"
                value={options.value}
                onChange={(e) => options.editorCallback(e.target.value)}
              />
            )}
            body={(item) => (
              <Button icon={<MeaSvgIcon document={item} />} text severity="contrast" className="hover:bg-gray-200 pt-1 pb-1 " onClick={(e) => {
                e.stopPropagation();
                if (item.is_folder) {
                  setState((s) => ({
                    documentsPage: 1,
                    parentId: item.id ? item.id : "",
                  }));
                } else {
                  documentsAPI.DownloadFile(schoolId, trainingId, accessToken, item.id).then((data) => {
                    const link = document.createElement('a');
                    link.href = data?.link;
                    link.setAttribute(
                      'download',
                      item?.name,
                    );

                    // Append to html link element page
                    document.body.appendChild(link);

                    // Start download
                    link.click();

                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                  }
                  );
                }

              }} label={<span className="pl-1 text-left">{item.name}</span>} />

            )}
          ></Column>
        )}
        {selectedData.presentation && (
          <Column field="presentation" header="Description"></Column>
        )}

        {selectedData.edit && (
          <Column
            body={(item) => (
              <>
                <MeaButton
                  icon="pi pi-pencil"
                  rounded
                  text
                  style={{ padding: "0", height: "1.5rem" }}
                  aria-label="Filter"
                  onClick={() => {

                    setDocumentObject(item);
                    if (updateModalRef.current) {
                      updateModalRef.current.show(() => {
                        queryList.refetch();
                      });
                    }
                  }}
                  permission={PERMISSION_TRAINING_CLASSROOMS.UPDATE}
                />
              </>
            )}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        )}
      </MeaDataTable>
      <UpdateDocumentModal ref={updateModalRef} document={documentObject} />
    </>
  );
});

export default DocumentsListComponent;
